import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
export interface DialogHelpData {
  title: string;
  message: string;
}
@Component({
    // tslint:disable-next-line:component-selector
    selector: 'app-help-dialog',
    templateUrl: 'dialog-help.component.html',
    standalone: false
})
export class DialogHelpComponent {
  constructor(
    public dialogRef: MatDialogRef<DialogHelpComponent>,
    @Inject(MAT_DIALOG_DATA) public data: DialogHelpData
  ) {}

  public onClickClose(): void {
    this.dialogRef.close();
  }
}
